// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* variables used throughout our scss AND bootstrap variables */
.light-gray {
  color: #f3f3f3 !important;
}

.dark-gray {
  color: #4a4a4a !important;
}

.mid-gray {
  color: #dcdcdc !important;
}

.icon-gray {
  color: #9e9fa1 !important;
}

.red {
  color: #da291c !important;
}

.dark-red {
  color: #af2218 !important;
}

.white {
  color: #fff !important;
}

.duckegg-blue {
  color: #e4f4fd !important;
}

.powder-blue {
  color: #deecfd !important;
}

.light-blue {
  color: #35b2e2 !important;
}

.link-blue {
  color: #007bff !important;
}

.blue {
  color: #009cde !important;
}

.dark-blue {
  color: #025a95 !important;
}

.teal {
  color: #01a3b0 !important;
}

.light-yellow {
  color: #fce8b6 !important;
}

.yellow {
  color: #f0b323 !important;
}

.orange {
  color: #df6d00 !important;
}

.green {
  color: #5ba400 !important;
}

.filter-light-gray {
  filter: invert(100%) sepia(5%) saturate(88%) hue-rotate(108deg) brightness(109%) contrast(91%);
}

.filter-dark-gray {
  filter: invert(17%) sepia(57%) saturate(0%) hue-rotate(201deg) brightness(105%) contrast(70%);
}

.filter-icon-gray {
  filter: invert(78%) sepia(6%) saturate(48%) hue-rotate(182deg) brightness(82%) contrast(84%);
}

.filter-mid-gray {
  filter: invert(26%) sepia(0%) saturate(0%) hue-rotate(36deg) brightness(99%) contrast(87%);
}

.filter-red {
  filter: invert(19%) sepia(48%) saturate(6736%) hue-rotate(356deg) brightness(91%) contrast(86%);
}

.filter-dark-red {
  filter: invert(17%) sepia(80%) saturate(2657%) hue-rotate(347deg) brightness(92%) contrast(108%);
}

.filter-white {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
}

.filter-duckegg-blue {
  filter: invert(90%) sepia(7%) saturate(746%) hue-rotate(183deg) brightness(103%) contrast(104%);
}

.filter-powder-blue {
  filter: invert(80%) sepia(14%) saturate(308%) hue-rotate(180deg) brightness(112%) contrast(98%);
}

.filter-light-blue {
  filter: invert(70%) sepia(90%) saturate(1920%) hue-rotate(164deg) brightness(90%) contrast(97%);
}

.filter-link-blue {
  filter: invert(25%) sepia(91%) saturate(1698%) hue-rotate(175deg) brightness(99%) contrast(101%);
}

.filter-blue {
  filter: invert(41%) sepia(38%) saturate(4547%) hue-rotate(172deg) brightness(101%) contrast(101%);
}

.filter-dark-blue {
  filter: invert(18%) sepia(85%) saturate(2810%) hue-rotate(189deg) brightness(93%) contrast(98%);
}

.filter-teal {
  filter: invert(57%) sepia(73%) saturate(4947%) hue-rotate(154deg) brightness(94%) contrast(99%);
}

.filter-light-yellow {
  filter: invert(99%) sepia(37%) saturate(4613%) hue-rotate(298deg) brightness(129%) contrast(98%);
}

.filter-yellow {
  filter: invert(61%) sepia(74%) saturate(484%) hue-rotate(3deg) brightness(106%) contrast(88%);
}

.filter-green {
  filter: invert(48%) sepia(30%) saturate(4387%) hue-rotate(56deg) brightness(101%) contrast(101%);
}

.filter-orange {
  filter: invert(44%) sepia(96%) saturate(2493%) hue-rotate(12deg) brightness(97%) contrast(102%);
}

.filter-white {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
}

.stroke-dark-blue {
  stroke: #025a95;
}

.expand svg {
  width: 25px !important;
  height: 25px !important;
  margin: 5px !important;
  padding: 0px !important;
  border-radius: 0px !important;
  background-color: transparent !important;
}

.expandTableBg {
  background-color: #fff !important;
}
.expandTableBg .expandTable {
  background-color: #f3f3f3 !important;
}

.reviewDetails {
  width: auto;
}

.resourceWidth {
  width: 1360px;
  margin: 0 0.5px 0 0;
  padding: 24px 24px 40px;
  border-radius: 6px;
  background-color: #fff;
}

.resourceInnerContainer {
  border: 12px solid #e4f4fd;
  padding: 24px;
}

.shiftContainer {
  border: 1px solid #dcdcdc;
  padding: 12px;
  border-radius: 6px;
  margin-top: 24px;
  margin-bottom: 24px;
}

.resourceWidth .modal-body {
  padding: 0px !important;
  margin: 10px !important;
}
.resourceWidth .headerContainer {
  width: auto !important;
}

.responseForm {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
}
.responseForm .responseLabel {
  font-size: 16px;
  font-weight: bold;
  margin-right: 10px;
}
.responseForm .form-check-input {
  width: 20px;
  height: 20px;
}
.responseForm span {
  margin: 0px 5px;
  color: #da291c;
}`, "",{"version":3,"sources":["webpack://./src/lib/styles/scss/variables/_vars-colors.scss","webpack://./src/pages/PurchaseOrder/PurchsaseOrderPendingRates/PurchaseOrderPendingRates.scss"],"names":[],"mappings":"AAAC,+DAAA;AAqHD;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,sBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADuHA;EACE,8FA1HkB;ACMpB;;ADuHA;EACE,6FA5HiB;ACQnB;;ADuHA;EACE,4FA9HiB;ACUnB;;ADuHA;EACE,0FAhIgB;ACYlB;;ADuHA;EACE,+FAjIW;ACab;;ADuHA;EACE,gGAnIgB;ACelB;;ADuHA;EACE,6FAtGa;ACdf;;ADuHA;EACE,+FArIoB;ACiBtB;;ADuHA;EACE,+FAvImB;ACmBrB;;ADuHA;EACE,+FAzIkB;ACqBpB;;ADsHA;EACE,gGAtIiB;ACmBnB;;ADqHA;EACE,iGA7IY;AC2Bd;;ADqHA;EACE,+FA/IiB;AC6BnB;;ADqHA;EACE,+FA9IY;AC4Bd;;ADqHA;EACE,gGA/IoB;AC6BtB;;ADqHA;EACE,6FAjJc;AC+BhB;;ADqHA;EACE,gGAlJa;ACgCf;;ADqHA;EACE,+FAnJc;ACiChB;;ADoHA;EACE,6FAnJa;ACkCf;;ADoHA;EACE,eAzOU;ACwHZ;;AApJE;EACE,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,wCAAA;AAuJJ;;AApJA;EACE,iCAAA;AAuJF;AAtJE;EACE,oCAAA;AAwJJ;;AApJA;EACE,WAAA;AAuJF;;AApJA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AAuJF;;AApJA;EACE,0BAAA;EACA,aAAA;AAuJF;;AArJA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAwJF;;AApJE;EACE,uBAAA;EACA,uBAAA;AAuJJ;AArJE;EACE,sBAAA;AAuJJ;;AApJA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAuJF;AAtJE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AAwJJ;AAtJE;EACE,WAAA;EACA,YAAA;AAwJJ;AAtJE;EACE,eAAA;EACA,cAAA;AAwJJ","sourcesContent":["﻿/* variables used throughout our scss AND bootstrap variables */\n\n//----------------------------------------------\n// COLORS\n//----------------------------------------------\n$gray-100: #f3f3f3;\n$gray-200: #eceff3;\n$gray-300: #dcdcdc;\n$gray-400: #f5f7f9;\n$gray-600: #9e9fa1;\n$gray-900: #4a4a4a;\n\n$darker-gray:#e2e6ea;\n$dark-gray: $gray-900;\n$icon-gray: $gray-600;\n$mid-gray: $gray-300;\n$lighter-gray: $gray-400;\n$fade-gray: $gray-200;\n$light-gray: $gray-100;\n\n$red: #da291c;\n$light-red: #fae1e2;\n$dark-red: #af2218;\n\n$white: #fff;\n$black: #000;\n\n$duckegg-blue: #e4f4fd;\n$powder-blue: #deecfd;\n$light-blue: #35b2e2;\n$blue: #009cde;\n$dark-blue: #025a95;\n$darker-blue: #1f74b9;\n$link-blue: #007bff;\n$link-hover: #0056b3;\n$faint-blue: #d0ecf8;\n\n$teal: #01a3b0;\n\n$light-yellow: #fce8b6;\n$yellow: #f0b323;\n\n$green: #5ba400;\n$dark-green: #367600;\n$light-green: #edf2e6;\n\n$light-orange: #fcebd2;\n$orange: #df6d00;\n\n$svg-colors: (\n  'icon-gray': $icon-gray,\n  'dark-gray': $dark-gray,\n  'red': $red,\n  'dark-red': $dark-red,\n  'blue': $blue,\n  'dark-blue': $dark-blue,\n  'link-blue': $link-blue,\n  'duckegg-blue': $duckegg-blue,\n  'green': $green,\n  'orange': $orange,\n  'teal': $teal,\n  'yellow': $yellow,\n  'white': $white,\n);\n\n//----------------------------------------------\n// FILTER COLORS\n//----------------------------------------------\n$filter-class: '';\n$filter-light-gray: invert(100%) sepia(5%) saturate(88%) hue-rotate(108deg)\n  brightness(109%) contrast(91%);\n$filter-dark-gray: invert(17%) sepia(57%) saturate(0%) hue-rotate(201deg)\n  brightness(105%) contrast(70%);\n$filter-icon-gray: invert(78%) sepia(6%) saturate(48%) hue-rotate(182deg)\n  brightness(82%) contrast(84%);\n$filter-mid-gray: invert(26%) sepia(0%) saturate(0%) hue-rotate(36deg)\n  brightness(99%) contrast(87%);\n\n$filter-red: invert(19%) sepia(48%) saturate(6736%) hue-rotate(356deg)\n  brightness(91%) contrast(86%);\n$filter-dark-red: invert(17%) sepia(80%) saturate(2657%) hue-rotate(347deg)\n  brightness(92%) contrast(108%);\n\n$filter-white: invert(98%) sepia(100%) saturate(0%) hue-rotate(301deg)\n  brightness(102%) contrast(101%);\n\n$filter-duckegg-blue: invert(90%) sepia(7%) saturate(746%) hue-rotate(183deg)\n  brightness(103%) contrast(104%);\n$filter-powder-blue: invert(80%) sepia(14%) saturate(308%) hue-rotate(180deg)\n  brightness(112%) contrast(98%);\n$filter-light-blue: invert(70%) sepia(90%) saturate(1920%) hue-rotate(164deg)\n  brightness(90%) contrast(97%);\n$filter-blue: invert(41%) sepia(38%) saturate(4547%) hue-rotate(172deg)\n  brightness(101%) contrast(101%);\n$filter-dark-blue: invert(18%) sepia(85%) saturate(2810%) hue-rotate(189deg)\n  brightness(93%) contrast(98%);\n$filter-link-blue: invert(25%) sepia(91%) saturate(1698%) hue-rotate(175deg)\n  brightness(99%) contrast(101%);\n\n$filter-teal: invert(57%) sepia(73%) saturate(4947%) hue-rotate(154deg)\n  brightness(94%) contrast(99%);\n\n$filter-light-yellow: invert(99%) sepia(37%) saturate(4613%) hue-rotate(298deg)\n  brightness(129%) contrast(98%);\n$filter-yellow: invert(61%) sepia(74%) saturate(484%) hue-rotate(3deg)\n  brightness(106%) contrast(88%);\n\n$filter-green: invert(48%) sepia(30%) saturate(4387%) hue-rotate(56deg)\n  brightness(101%) contrast(101%);\n\n$filter-orange: invert(44%) sepia(96%) saturate(2493%) hue-rotate(12deg)\n  brightness(97%) contrast(102%);\n\n$filter-white: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)\n  brightness(103%) contrast(103%);\n\n// COLOR CLASSES\n.light-gray {\n  color: $light-gray !important;\n}\n\n.dark-gray {\n  color: $dark-gray !important;\n}\n\n.mid-gray {\n  color: $mid-gray !important;\n}\n\n.icon-gray {\n  color: $icon-gray !important;\n}\n\n.red {\n  color: $red !important;\n}\n\n.dark-red {\n  color: $dark-red !important;\n}\n\n.white {\n  color: $white !important;\n}\n\n.duckegg-blue {\n  color: $duckegg-blue !important;\n}\n\n.powder-blue {\n  color: $powder-blue !important;\n}\n\n.light-blue {\n  color: $light-blue !important;\n}\n\n.link-blue {\n  color: $link-blue !important;\n}\n\n.blue {\n  color: $blue !important;\n}\n\n.dark-blue {\n  color: $dark-blue !important;\n}\n\n.teal {\n  color: $teal !important;\n}\n\n.light-yellow {\n  color: $light-yellow !important;\n}\n\n.yellow {\n  color: $yellow !important;\n}\n\n.orange {\n  color: $orange !important;\n}\n\n.green {\n  color: $green !important;\n}\n\n// FILTER CLASSES\n.filter-light-gray {\n  filter: $filter-light-gray;\n}\n\n.filter-dark-gray {\n  filter: $filter-dark-gray;\n}\n\n.filter-icon-gray {\n  filter: $filter-icon-gray;\n}\n\n.filter-mid-gray {\n  filter: $filter-mid-gray;\n}\n\n.filter-red {\n  filter: $filter-red;\n}\n\n.filter-dark-red {\n  filter: $filter-dark-red;\n}\n\n.filter-white {\n  filter: $filter-white;\n}\n\n.filter-duckegg-blue {\n  filter: $filter-duckegg-blue;\n}\n\n.filter-powder-blue {\n  filter: $filter-powder-blue;\n}\n\n.filter-light-blue {\n  filter: $filter-light-blue;\n}\n.filter-link-blue {\n  filter: $filter-link-blue;\n}\n.filter-blue {\n  filter: $filter-blue;\n}\n\n.filter-dark-blue {\n  filter: $filter-dark-blue;\n}\n\n.filter-teal {\n  filter: $filter-teal;\n}\n\n.filter-light-yellow {\n  filter: $filter-light-yellow;\n}\n\n.filter-yellow {\n  filter: $filter-yellow;\n}\n\n.filter-green {\n  filter: $filter-green;\n}\n\n.filter-orange {\n  filter: $filter-orange;\n}\n.filter-white {\n  filter: $filter-white;\n}\n\n.stroke-dark-blue {\n  stroke: $dark-blue;\n}\n","@import 'lib/styles/scss/variables/_vars-colors.scss';\n\n.expand {\n  svg {\n    width: 25px !important;\n    height: 25px !important;\n    margin: 5px !important;\n    padding: 0px !important;\n    border-radius: 0px !important;\n    background-color: transparent !important;\n  }\n}\n.expandTableBg {\n  background-color: $white !important;\n  .expandTable {\n    background-color: #f3f3f3 !important;\n  }\n}\n\n.reviewDetails {\n  width: auto;\n}\n\n.resourceWidth {\n  width: 1360px;\n  margin: 0 0.5px 0 0;\n  padding: 24px 24px 40px;\n  border-radius: 6px;\n  background-color: #fff;\n}\n\n.resourceInnerContainer {\n  border: 12px solid $duckegg-blue;\n  padding: 24px;\n}\n.shiftContainer {\n  border: 1px solid $mid-gray;\n  padding: 12px;\n  border-radius: 6px;\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n\n.resourceWidth {\n  .modal-body {\n    padding: 0px !important;\n    margin: 10px !important;\n  }\n  .headerContainer {\n    width: auto !important;\n  }\n}\n.responseForm {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: row;\n  .responseLabel {\n    font-size: 16px;\n    font-weight: bold;\n    margin-right: 10px;\n  }\n  .form-check-input {\n    width: 20px;\n    height: 20px;\n  }\n  span {\n    margin: 0px 5px;\n    color: #da291c;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
